<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="150px" ref="form" :rules="rules" label-position="left" v-loading="loading">
        <el-form-item label="组织架构" prop="org_id">
          <el-cascader v-model="form_data.org_id" :options="org_tree_node" :props="{ checkStrictly: true }" clearable></el-cascader>
        </el-form-item>

      <el-form-item label="负责人姓名" prop="org_charger">
        <el-input v-model="form_data.org_charger" autocomplete="off" placeholder="请输入负责人姓名"></el-input>
      </el-form-item>
      <el-form-item label="负责人电话" prop="org_charger_tel">
        <el-input v-model="form_data.org_charger_tel" autocomplete="off" placeholder="请输入负责人电话"></el-input>
      </el-form-item>

      <el-form-item label="联系人姓名" prop="org_contact">
        <el-input v-model="form_data.org_contact" autocomplete="off" placeholder="请输入联系人姓名"></el-input>
      </el-form-item>

      <el-form-item label="联系人电话" prop="org_contact_tel">
        <el-input v-model="form_data.org_contact_tel" autocomplete="off" placeholder="请输入联系人电话"></el-input>
      </el-form-item>

      <el-form-item label="管理模块类型" prop="moduler_ids">
        <el-select v-model="form_data.moduler_ids" multiple placeholder="请选择模块类型(可多选)" :disabled="moduler_list.length==0  ">
          <el-option v-for="item in moduler_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </el-form-item>


    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "l-org-duty-edit",
  props: {
    id: {
      type: [Number, String],
      default: null,
    },

    org_id: {
      type: [Number, String],
      default: "",
    },
    visible: {
      type: Boolean,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      loading: false,
      tree_node: [],
      moduler_list: [],
      // street_list:[],
      // community_list:[],
      // place_type_list:[],
      //表单数据
      submitting: false,
      org_tree_node: [],
      form_data: {
        // pid: 1,
        org_name: "",
        type: 2,
        company_type: 2,
        code: "",
        moduler_ids: [],
        // is_force_hall: 0,
        // is_force_dev_code: 0,
        // street_ids: [],
        // community_ids:[],
        // place_type_list:[],
      },

      p_info: {},

      rules: {
        pid: [
          {
            type: "number",
            required: true,
            message: "请选择上级组织",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "number",
            required: true,
            message: "请选择组织类型",
            trigger: "change",
          },
        ],
        name: [
          { required: true, message: "请输入组织名称", trigger: "change" },
        ],
        short_name: [
          { required: true, message: "请输入企业简称", trigger: "change" },
        ],
      },
    };
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          // console.log(this.$props.pid);
          this.getData();
        }
      },
    },
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },
    

    //获取添加数据
    getData() {

      if (this.hasId) {
        this.loading = true;
        //编辑获取数据
        this.$_invoke("uniOrg_getEditData", { id: this.$props.id })
          .then((ret) => {
            let { tree_node, list, data, is_company } = ret;
            this.tree_node = tree_node;
            this.module_list = ret.module_list;
            this.$nextTick(() => {
              if (!is_company) {
                //找到pid所属的路径
                const curr_p_data = list.find((item) => {
                  return item.id == data.pid;
                });

                // console.log(curr_p_data);
                let p_path_arr = curr_p_data.path.split(">");
                p_path_arr = p_path_arr.filter((item) => {
                  return item != "";
                });
                p_path_arr.push(data.pid);
                p_path_arr = p_path_arr.map((item) => {
                  return parseInt(item);
                });
                p_path_arr.splice(0, 1);
                data.pid = p_path_arr;
              } else {
                data.pid = [data.pid];
              }

              this.form_data = data;
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }else {
        this.$_invoke("uniOrg_getOrgDutyAddData", {
      
        })
          .then((ret) => {
            // console.log(ret)
            this.org_tree_node = ret.org_tree_node;
             this.moduler_list = ret.moduler_list;
             this.form_data.org_id = this.$props.org_id;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
            if (typeof this.form_data.org_id != "number" && this.form_data.org_id.length != 0) {
              const org_id_len = this.form_data.org_id.length;
              this.form_data.org_id = this.form_data.org_id[org_id_len - 1];
            } else {
                // this.form_data.org_id = this.form_data.org_id;
            }
          this.submitting = true;
          // this.form_data.pid = this.$props.pid;
          if (!this.hasId) {
            //添加
            this.$_invoke("uniOrg_saveOrgDuty", this.form_data)
              .then(() => {
                this.$_msg.success("添加成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          } else {
            //修改
            this.$_invoke(`uniOrg_updateOrgDuty`, this.form_data)
              .then(() => {
                this.$_msg.success("修改成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        }
      });
    },
  },
};
</script>
